import { loadTossPayments } from '@tosspayments/tosspayments-sdk';
import { useEffect, useState, useCallback, useMemo } from 'react';
import store from '../../store';

const generateRandomString = () => window.btoa(Math.random()).slice(0, 20);

export const TossCheckoutPage = ({
  show,
  onClose,
  productName,
  payAmount,
  successUrl,
  user_id,
  user_uuid,
  isEnterprise = false,
}) => {
  // 상태 관리
  const [ready, setReady] = useState(false);
  const [widgets, setWidgets] = useState(null);
  const [error, setError] = useState(null);

  // useMemo로 변경하여 불필요한 상태 관리 제거
  const clientKey = useMemo(() => {
    const isDevelopment = process.env.REACT_APP_LOCATION === 'develop';
    const isTestManager = store.getState().username === process.env.REACT_APP_MANAGER3;
    console.log('🚀 ~ paymentModal.js:25 ~ TossCheckoutPage ~ isDevelopment:', isDevelopment);
    console.log('🚀 ~ paymentModal.js:26 ~ TossCheckoutPage ~ isTestManager:', isTestManager);

    return isDevelopment || isTestManager
      ? process.env.REACT_APP_TOSS_WIDGET_CLIENTKEY_TEST
      : process.env.REACT_APP_TOSS_WIDGET_CLIENTKEY;
  }, []);
  console.log('🚀 ~ paymentModal.js:33 ~ TossCheckoutPage ~ clientKey:', clientKey);

  const amount = useMemo(() => {
    const isSpecialPriceUser = store.getState().username === process.env.REACT_APP_MANAGER4;

    return {
      currency: 'KRW',
      value: isSpecialPriceUser ? 1000 : payAmount,
    };
  }, [payAmount]);

  // 토스페이먼츠 위젯 초기화
  useEffect(() => {
    if (!show) return; // 모달이 표시되지 않으면 초기화하지 않음

    // 사용자 정보 검증
    if (!user_id || !user_uuid) {
      setError('사용자 정보가 누락되었습니다');
      return;
    }

    async function fetchPaymentWidgets() {
      try {
        const tossPayments = await loadTossPayments(clientKey);

        const customerKey = `${user_uuid}${user_id}`;
        const redirectUrl = `${process.env.REACT_APP_API_URL}web/toss/branpay/auth`;

        const widgetsInstance = tossPayments.widgets({
          customerKey,
          brandpay: {
            redirectUrl,
          },
        });

        setWidgets(widgetsInstance);
      } catch (err) {
        setError(`위젯 초기화 오류: ${err.message || err}`);
      }
    }

    fetchPaymentWidgets();
    // 모달이 닫힐 때 정리
    return () => {
      setWidgets(null);
      setReady(false);
    };
  }, [show, clientKey, user_id, user_uuid]);

  // 위젯 렌더링
  useEffect(() => {
    if (!widgets || !show) return;

    async function renderPaymentWidgets() {
      try {
        await widgets.setAmount(amount);
        const variantKey = isEnterprise ? 'ENTERPRISE' : 'DEFAULT';
        await Promise.all([
          widgets.renderPaymentMethods({
            selector: '#payment-method',
            variantKey: variantKey,
          }),
          widgets.renderAgreement({
            selector: '#agreement',
            variantKey: 'AGREEMENT',
          }),
        ]);

        setReady(true);
      } catch (err) {
        setError(`위젯 렌더링 오류: ${err.message || err}`);
        setReady(false);
      }
    }

    // setTimeout으로 DOM 렌더링 보장
    const timerId = setTimeout(() => {
      renderPaymentWidgets();
    }, 100);

    return () => {
      clearTimeout(timerId);
    };
  }, [widgets, amount, show]);

  // 결제 처리 함수
  const handlePayment = useCallback(async () => {
    if (!widgets || !ready) return;

    try {
      // 결제 요청 먼저 시도
      await widgets.requestPayment({
        orderId: generateRandomString(),
        orderName: productName,
        successUrl: successUrl,
        failUrl: successUrl,
        customerEmail: store.getState().useremail,
        customerName: store.getState().name,
      });
      // 성공 시에만 모달 닫기
      onClose();
    } catch (err) {
      alert(`결제 처리 중 오류가 발생했습니다: ${err.message || err}`);
    }
  }, [widgets, ready, productName, successUrl, onClose]);

  // 모달이 표시되지 않으면 렌더링하지 않음
  if (!show) return null;

  // 에러 표시 UI
  if (error) {
    return (
      <div className="payment-error" style={{ padding: '20px', textAlign: 'center' }}>
        <h3>결제 위젯 초기화 오류</h3>
        <p>{error}</p>
        <button onClick={onClose} style={{ padding: '8px 16px', marginTop: '15px' }}>
          닫기
        </button>
      </div>
    );
  }

  return (
    <div
      className="wrapper w-100"
      style={{ display: 'flex', alignItems: 'center', width: '100%', padding: '24px 0', flexDirection: 'column' }}
    >
      <div className="max-w-540 w-100" style={{ width: '100%' }}>
        <div id="payment-method" className="w-100" style={{ width: '100%' }} />
        <div id="agreement" className="w-100" style={{ width: '100%' }} />
        <div className="btn-wrapper w-100" style={{ width: '90%', padding: '0 24px' }}>
          <button
            className="btn primary w-100"
            style={{
              width: '100%',
              backgroundColor: '#3282f6',
              color: '#f9fcff',
              fontSize: 17,
              cursor: ready ? 'pointer' : 'not-allowed',
              borderRadius: 8,
              border: 'none',
              padding: '11px 22px',
              opacity: ready ? 1 : 0.7,
            }}
            disabled={!ready}
            onClick={handlePayment}
          >
            {ready ? '결제하기' : '결제 준비 중...'}
          </button>
        </div>
      </div>
    </div>
  );
};
